import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app.tsx";
import AppProvider from "./contexts/app.context.tsx";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
);
